import React from "react";

function LatestBlog() {
  return (
    <>
      {/* Blog Start */}
      <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container py-5">
          <div
            className="section-title text-center position-relative pb-3 mb-5 mx-auto"
            style={{maxWidth: "600px"}}>
            <h5 className="fw-bold text-primary text-uppercase">Latest Blog</h5>
            <h1 className="mb-0">Read The Latest Articles from Our Blog Post</h1>
          </div>
          <div className="row g-5">
            <div className="col-lg-4 wow slideInUp" data-wow-delay="0.3s">
              <div className="blog-item bg-light rounded overflow-hidden">
                <div className="blog-img position-relative overflow-hidden">
                  <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Social Media Marketing for diff. Industries.jpg" alt="Social Media Marketing" />
                  <a
                    className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4"
                    href="#"
                    >Social Media</a
                  >
                </div>
                <div className="p-4">
                  <div className="d-flex mb-3">
                    <small className="me-3">
                      <i className="far fa-user text-primary me-2"></i>Anwar Hussain</small>
                    <small><i className="far fa-calendar-alt text-primary me-2"></i> 22nd Jan, 2024
                      </small>
                  </div>
                  <h4 className="mb-3">Social Media Marketing By Industry
                  </h4>
                  <a className="text-uppercase" href="https://www.brandliftmm.com/blog/smm-by-industry.html"
                    >Read More <i className="bi bi-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow slideInUp" data-wow-delay="0.6s">
              <div className="blog-item bg-light rounded overflow-hidden">
                <div className="blog-img position-relative overflow-hidden">
                  <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Generating Online Leads Through Social Media Marketing.jpg" alt="Generating Leads" />
                  <a
                    className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4"
                    href="#"
                    >Social Media</a
                  >
                </div>
                <div className="p-4">
                  <div className="d-flex mb-3">
                    <small className="me-3">
                      <i className="far fa-user text-primary me-2"></i>Anwar Hussain</small>
                    <small><i className="far fa-calendar-alt text-primary me-2"></i>12th Jan, 2024
                      </small>
                  </div>
                  <h4 className="mb-3">
                    Generating Leads Through Social Media Marketing
                  </h4>
                  <a className="text-uppercase" href="https://www.brandliftmm.com/blog/generating-leads-through-smm.html">Read More..<i className="bi bi-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
            <div className="col-lg-4 wow slideInUp" data-wow-delay="0.9s">
              <div className="blog-item bg-light rounded overflow-hidden">
                <div className="blog-img position-relative overflow-hidden">
                  <img className="img-fluid" src="/img/400 x 280-20240128T111714Z-001/400 x 280/Cheap Social Media Services.jpg" alt="Affordable Services" />
                  <a className="position-absolute top-0 start-0 bg-primary text-white rounded-end mt-5 py-2 px-4"
                    href="">Social Media</a>
                </div>
                <div className="p-4">
                  <div className="d-flex mb-3">
                    <small className="me-3"
                      ><i className="far fa-user text-primary me-2"></i>Anwar Hussain</small>
                    <small
                      ><i className="far fa-calendar-alt text-primary me-2"></i>
                      3nd Jan, 2024

                    </small>
                  </div>
                  <h4 className="mb-3">Affordable Social Media Services by Brand Lift.
                  </h4>
                  <a className="text-uppercase" href="https://www.brandliftmm.com/blog/affordable-marketing-services.html"
                    >Read More <i className="bi bi-arrow-right"></i
                  ></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Blog Section Ends here */}
    </>
  );
}

export default LatestBlog;
